<template>
  <q-chip
    v-if="effectiveScenario === EFFECTIVE_SCENARIOS.SALES"
    size="lg"
    dense
    square
    text-color="white"
    color="green-7"
    label="Sale"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <div class="column items-center">
                <q-chip
                  size="lg"
                  dense
                  square
                  color="green-9"
                  text-color="white"
                  label="Placed"
                />
              </div>
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.VOIDS"
    size="lg"
    dense
    square
    text-color="white"
    color="red-7"
    label="Voids"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <div class="column items-center">
                <q-chip
                  size="lg"
                  dense
                  square
                  color="red-9"
                  text-color="white"
                  label="Voided"
                />
              </div>
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.ACCRUAL"
    size="lg"
    dense
    square
    text-color="white"
    color="blue-7"
    label="Effective"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <div class="column items-center">
                <q-chip
                  class="col"
                  size="lg"
                  dense
                  square
                  color="blue-7"
                  text-color="white"
                  label="Effective"
                />
              </div>
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.CURRENT_SALES"
    size="lg"
    dense
    square
    text-color="white"
    color="green-7"
    label="Current Sales"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <div class="column items-center">
                <q-chip
                  class="col"
                  size="lg"
                  dense
                  square
                  color="blue-7"
                  text-color="white"
                  label="Effective"
                />
                <q-chip
                  size="lg"
                  dense
                  square
                  color="green-9"
                  text-color="white"
                  label="Placed"
                />
              </div>
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.FUTURE_SALES"
    size="lg"
    dense
    square
    text-color="white"
    color="green-7"
    label="Future Sales"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <q-chip
                size="lg"
                dense
                square
                color="green-9"
                text-color="white"
                label="Placed"
              />
            </td>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="blue-7"
                text-color="white"
                label="Effective"
              />
            </td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.MATURING_SALES"
    size="lg"
    dense
    square
    text-color="white"
    color="green-7"
    label="Maturing Sales"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <q-chip
                size="lg"
                dense
                square
                color="green-9"
                text-color="white"
                label="Placed"
              />
            </td>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="blue-7"
                text-color="white"
                label="Effective"
              />
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.PAST_SALES"
    size="lg"
    dense
    square
    text-color="white"
    color="green-7"
    label="Past Sales"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="blue-7"
                text-color="white"
                label="Effective"
              />
            </td>
            <td>
              <q-chip
                size="lg"
                dense
                square
                color="green-9"
                text-color="white"
                label="Placed"
              />
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.RETROACTIVE_SALES"
    size="lg"
    dense
    square
    text-color="white"
    color="green-7"
    label="Retroactive Sales"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="blue-7"
                text-color="white"
                label="Effective"
              />
            </td>
            <td>
              <q-chip
                size="lg"
                dense
                square
                color="green-9"
                text-color="white"
                label="Placed"
              />
            </td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.CURRENT_VOIDS"
    size="lg"
    dense
    square
    text-color="white"
    color="red-7"
    label="Current Voids"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <div class="column items-center">
                <q-chip
                  class="col"
                  size="lg"
                  dense
                  square
                  color="blue-7"
                  text-color="white"
                  label="Effective"
                />
                <q-chip
                  size="lg"
                  dense
                  square
                  color="red-9"
                  text-color="white"
                  label="Voided"
                />
              </div>
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.FUTURE_VOIDS"
    size="lg"
    dense
    square
    text-color="white"
    color="red-7"
    label="Future Voids"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <q-chip
                size="lg"
                dense
                square
                color="red-9"
                text-color="white"
                label="Voided"
              />
            </td>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="blue-7"
                text-color="white"
                label="Effective"
              />
            </td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.MATURING_VOIDS"
    size="lg"
    dense
    square
    text-color="white"
    color="red-7"
    label="Maturing Voids"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <q-chip
                size="lg"
                dense
                square
                color="red-9"
                text-color="white"
                label="Voided"
              />
            </td>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="blue-7"
                text-color="white"
                label="Effective"
              />
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.PAST_VOIDS"
    size="lg"
    dense
    square
    text-color="white"
    color="red-7"
    label="Past Voids"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="blue-7"
                text-color="white"
                label="Effective"
              />
            </td>
            <td>
              <q-chip
                size="lg"
                dense
                square
                color="red-9"
                text-color="white"
                label="Voided"
              />
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.CURRENT_PAYMENTS"
    size="lg"
    dense
    square
    text-color="white"
    color="green-7"
    label="Current Payments"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <div class="column items-center">
                <q-chip
                  class="col"
                  size="lg"
                  dense
                  square
                  color="green-7"
                  text-color="white"
                  label="Placed"
                />
                <q-chip
                  class="col"
                  size="lg"
                  dense
                  square
                  color="green-9"
                  text-color="white"
                  label="Paid"
                />
              </div>
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.CURRENT_REFUNDS"
    size="lg"
    dense
    square
    text-color="white"
    color="red-7"
    label="Current Refunds"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <div class="column items-center">
                <q-chip
                  class="col"
                  size="lg"
                  dense
                  square
                  color="green-7"
                  text-color="white"
                  label="Placed"
                />
                <q-chip
                  class="col"
                  size="lg"
                  dense
                  square
                  color="red-9"
                  text-color="white"
                  label="Refunded"
                />
              </div>
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.CURRENT_UNPAID_PLACEMENTS"
    size="lg"
    dense
    square
    text-color="white"
    color="green-7"
    label="Current Unpaid Placements"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="green-7"
                text-color="white"
                label="Placed"
              />
            </td>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="green-9"
                outline
                text-color="white"
                label="Paid"
              />
            </td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.PAST_UNPAID_PLACEMENTS"
    size="lg"
    dense
    square
    text-color="white"
    color="green-7"
    label="Past Unpaid Placements"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="green-7"
                text-color="white"
                label="Placed"
              />
            </td>
            <td />
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="green-9"
                outline
                text-color="white"
                label="Paid"
              />
            </td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.CURRENT_UNPAID_VOIDS"
    size="lg"
    dense
    square
    text-color="white"
    color="red-7"
    label="Current Unpaid Voids"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <div class="column items-center">
                <q-chip
                  class="col"
                  size="lg"
                  dense
                  square
                  color="green-7"
                  text-color="white"
                  label="Placed"
                />
                <q-chip
                  class="col"
                  size="lg"
                  dense
                  square
                  color="red-7"
                  text-color="white"
                  label="Void"
                />
              </div>
            </td>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="green-9"
                outline
                text-color="white"
                label="Paid"
              />
            </td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.PAST_UNPAID_VOIDS"
    size="lg"
    dense
    square
    text-color="white"
    color="red-7"
    label="Past Unpaid Voids"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="green-7"
                text-color="white"
                label="Placed"
              />
            </td>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="red-7"
                text-color="white"
                label="Void"
              />
            </td>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="green-9"
                outline
                text-color="white"
                label="Paid"
              />
            </td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.PAID_PAST_PLACEMENTS"
    size="lg"
    dense
    square
    text-color="white"
    color="green-9"
    label="Paid Past Placements"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="green-7"
                text-color="white"
                label="Placed"
              />
            </td>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="green-9"
                text-color="white"
                label="Paid"
              />
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.RETROACTIVE_VOIDS"
    size="lg"
    dense
    square
    text-color="white"
    color="red-7"
    label="Retroactive Voids"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="blue-7"
                text-color="white"
                label="Effective"
              />
            </td>
            <td>
              <q-chip
                size="lg"
                dense
                square
                color="red-9"
                text-color="white"
                label="Voided"
              />
            </td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.PAID"
    size="lg"
    dense
    square
    text-color="white"
    color="green-7"
    label="Paid"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <q-chip
                size="lg"
                dense
                square
                color="green-8"
                text-color="white"
                label="Paid"
              />
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.REFUNDS"
    size="lg"
    dense
    square
    text-color="white"
    color="red-7"
    label="Refunds"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <q-chip
                size="lg"
                dense
                square
                color="red-8"
                text-color="white"
                label="Refund"
              />
            </td>
            <td />
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>

  <q-chip
    v-else-if="effectiveScenario === EFFECTIVE_SCENARIOS.ACCOUNTS_RECEIVABLE"
    size="lg"
    dense
    square
    text-color="white"
    color="green-7"
    label="Accounts Receivable"
    clickable
    class="scenario-chip col-auto q-px-lg"
  >
    <q-tooltip class="bg-grey-3">
      <q-markup-table
        separator="cell"
        flat
        bordered
        dense
        class="effective-timeline-table"
      >
        <thead>
          <tr>
            <th>Past Range</th>
            <th>Report Range</th>
            <th>Future Range</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td />
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="green-7"
                text-color="white"
                label="Placed"
              />
            </td>
            <td>
              <q-chip
                class="col"
                size="lg"
                dense
                square
                color="green-9"
                outline
                text-color="white"
                label="Paid"
              />
            </td>
          </tr>
        </tbody>
      </q-markup-table>
    </q-tooltip>
  </q-chip>
</template>

<script>

export const EFFECTIVE_SCENARIOS = {
  SALES: 'SALES',
  VOIDS: 'VOIDS',

  CURRENT_SALES: 'CURRENT_SALES',
  FUTURE_SALES: 'FUTURE_SALES',
  MATURING_SALES: 'MATURING_SALES',
  PAST_SALES: 'PAST_SALES',
  RETROACTIVE_SALES: 'RETROACTIVE_SALES',

  CURRENT_VOIDS: 'CURRENT_VOIDS',
  FUTURE_VOIDS: 'FUTURE_VOIDS',
  MATURING_VOIDS: 'MATURING_VOIDS',
  PAST_VOIDS: 'PAST_VOIDS',
  RETROACTIVE_VOIDS: 'RETROACTIVE_VOIDS',

  ACCRUAL: 'accrual',

  PAID: 'PAID',
  REFUNDS: 'REFUNDS',

  CURRENT_PAYMENTS: 'CURRENT_PAYMENTS',
  CURRENT_REFUNDS: 'CURRENT_REFUNDS',
  CURRENT_UNPAID_PLACEMENTS: 'CURRENT_UNPAID_PLACEMENTS',
  PAST_UNPAID_PLACEMENTS: 'PAST_UNPAID_PLACEMENTS',
  CURRENT_UNPAID_VOIDS: 'CURRENT_UNPAID_VOIDS',
  PAST_UNPAID_VOIDS: 'PAST_UNPAID_VOIDS',
  PAID_PAST_PLACEMENTS: 'PAID_PAST_PLACEMENTS',
  ACCOUNTS_RECEIVABLE: 'ACCOUNTS_RECEIVABLE'
}

export default {
  name: 'EffectiveScenario',
  props: {
    effectiveScenario: {
      type: String,
      required: false,
      default: null
    }
  },
  created () {
    _.extend(this, {
      EFFECTIVE_SCENARIOS
    })
  }
}

</script>

<style lang="scss">
.scenario-chip {
  min-width: 200px;
  height: 50px;
  margin: 10px 0px;
}
</style>
